import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import ResetPasswordEmailForm from './ResetPasswordEmailForm';

const styles = theme => ({
  root: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 556,
    },
  },
  form: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '50px 113px 0',
    },
  },
  button: {
    paddingTop: 15,
    paddingBottom: 15,
    width: '100%',
  },
  footer: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '30px 113px 50px',
    },
  },
});

const ResetPasswordEmail = ({
  form,
  submitting,
  onSubmitSuccess,
  actions,
  classes,
}) => (
  <Paper
    className={classes.root}
    square
    elevation={5}
  >
    <ResetPasswordEmailForm
      className={classes.form}
      form={form}
      onSubmitSuccess={onSubmitSuccess}
    />
    <div className={classes.footer}>
      <Button
        className={classes.button}
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Send Recovery Link
      </Button>
    </div>
  </Paper>
);

ResetPasswordEmail.propTypes = {
  form: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
  }).isRequired,
};

ResetPasswordEmail.defaultProps = {
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ResetPasswordEmail),
);



// WEBPACK FOOTER //
// ./src/components/account/ResetPasswordEmail/ResetPasswordEmail.js